import {
  Component, ElementRef, Input, OnInit
} from '@angular/core';
import {SimpleSearchField} from '../../../../../../services/simple-search/simple-search';
import {environment} from '../../../../../../../../environments';
import {AbstractGridFilter} from '../../../../generic-grid/filters/abstract-grid-filter';
import {GeocoderAutocomplete} from '@geoapify/geocoder-autocomplete';
import {GeoapifyProperties} from '../../../../../../form-viewer/models/geoapify-properties';

@Component({
  selector: 'app-leased-employee-region-search',
  template: `
    <div class="ui-g-12 no-padding">
      <div id="autocomplete-container" class="autocomplete-container"></div>
    </div>
  `,
  styles: [`
    .no-padding {
      padding: 0;
    }

    .autocomplete-container {
      position: relative;
    }

    ::ng-deep .geoapify-autocomplete-input {
      height: 20px;
      width: 264px;
      position: relative;
    }

    ::ng-deep .geoapify-autocomplete-items {
      width: 264px;
    }
  `]
})
export class LeasedEmployeeRegionComponent implements OnInit {
  @Input() public field: SimpleSearchField = null;
  public placesAutocompleteDistance: GeocoderAutocomplete = null;

  public constructor(private elementRef: ElementRef) {
  }

  public ngOnInit() {
    this.placesAutocompleteDistance = new GeocoderAutocomplete(
      this.elementRef.nativeElement.querySelector('#autocomplete-container'),
      environment.geoapifyApiKey
    );
    this.changeAutocompleteStyle();

    this.placesAutocompleteDistance.on('select', e => {
      if (e === null) {
        this.field.value = null;
        this.field.searchValue = null;
        this.field.labelValue = '';
      } else {
        const suggestion = e.properties;

        this.field.value.lat = suggestion.lat;
        this.field.value.lng = suggestion.lon;
        this.field.value.regionName = suggestion.state;
        this.field.labelValue = this.getSuggestionLabel(suggestion);
      }

      this.changeValue();
    });

    this.initDefaultValues();
  }

  public changeValue(): void {
    this.field.value = {
      lat: this.field.value.lat,
      lng: this.field.value.lng,
      regionName: this.field.value.regionName,
      fqnAware: 'PhoenixBundle\\Entity\\Address',
      context: 'leasedEmployeeRegion'
    };

    this.field.searchValue = JSON.stringify(this.field.value);
    this.field.skipSearch = !this.field.value.lat;
  }

  private getSuggestionLabel({ address_line1, postcode, city, country }: GeoapifyProperties): string {
    return `${address_line1 ? address_line1 + ' ' : ''}${postcode ? postcode + ' ' : ''}${city ? city + ', ' : ''}${country}`;
  }

  private initDefaultValues() {
    this.field.comparator = AbstractGridFilter.MATCH_MODE_LEASED_EMPLOYEE_REGION;
    this.field.value = this.field.value && this.field.value.context === 'leasedEmployeeRegion' ? this.field.value : {};
    this.field.value.fqnAware = 'PhoenixBundle\\Entity\\Address';
    this.field.value.context = 'leasedEmployeeRegion';
    this.field.searchKey = 'regions.region';
    this.field.embed = 'regions';

    if (this.field.labelValue) {
      this.placesAutocompleteDistance.setValue(this.field.labelValue);
    }

    this.field.skipSearch = !this.field.value.lat;
  }

  private changeAutocompleteStyle(): void {
    const inputElement = this.elementRef.nativeElement.querySelector('.geoapify-autocomplete-input');
    if (inputElement) {
      inputElement.setAttribute('placeholder', 'Geben Sie hier eine Adresse ein!');
    }
  }
}
